document.addEventListener('DOMContentLoaded', async function () {
    const tieredPricingWrapper = document.querySelector('.tiered-pricing-wrapper');
    const sectionRoot = tieredPricingWrapper ? tieredPricingWrapper.closest('[data-section-id]') : null;
    const sectionId = sectionRoot ? sectionRoot.dataset.sectionId : '';
    const baseUrl = window.location.pathname;
    const initialScript = document.getElementById('tiered-pricing-json');
    if (!initialScript) return;

    let pageData;
    try {
      pageData = JSON.parse(initialScript.textContent);
    } catch (e) {
      console.error('Failed to parse initial table JSON', e);
      return;
    }

    let allProducts = Array.isArray(pageData.products) ? [...pageData.products] : [];
    if (pageData.pages > 1) {
      const promises = [];
      for (let p = 2; p <= pageData.pages; p++) {
        promises.push(
          fetch(`${baseUrl}?section_id=${sectionId}&page=${p}`)
            .then((res) => res.text())
            .then((html) => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              const script = doc.getElementById('tiered-pricing-json');
              if (!script) return [];
              return JSON.parse(script.textContent).products || [];
            })
            .catch((err) => {
              console.error('Failed to fetch page', p, err);
              return [];
            })
        );
      }
      const results = await Promise.all(promises);
      results.forEach((items) => {
        allProducts = allProducts.concat(items);
      });
    }

    function detectTier(variant) {
      const tierSource = [
        variant.option1,
        variant.option2,
        variant.option3,
        variant.title,
      ]
        .filter(Boolean)
        .join(' ')
        .toLowerCase();

      if (tierSource.includes('pallet')) return 'pallet';
      if (tierSource.includes('bundle') || tierSource.includes('standard')) return 'bundle';
      return 'bundle';
    }

    const grouped = {};
    allProducts.forEach((prod) => {
      const groupKey = prod.table_group_key || prod.handle || String(prod.id);
      if (!grouped[groupKey]) {
        grouped[groupKey] = {
          bundle: null,
          pallet: null,
          dimensions_display: prod.dimensions_display || '',
        };
      }
      (prod.variants || []).forEach((v) => {
        const tier = detectTier(v);
        if (tier === 'pallet') grouped[groupKey].pallet = v;
        else grouped[groupKey].bundle = v;
      });
    });

    // Helper: parse L x W x H" from option1
    function parseDimensions(dimStr) {
      // handle fraction like "3 1/2" or "1/2"
      function parseNumber(str) {
        if (!str) return null;
        let s = str.replace(/"/g, '').replace(/'/g, '').trim();
        const spaceIdx = s.indexOf(' ');
        if (spaceIdx !== -1) {
          const whole = parseFloat(s.substring(0, spaceIdx));
          const fracStr = s.substring(spaceIdx + 1);
          if (fracStr.indexOf('/') !== -1) {
            const fParts = fracStr.split('/');
            const frac = (parseFloat(fParts[0]) || 0) / (parseFloat(fParts[1]) || 1);
            return (whole || 0) + frac;
          }
        } else if (s.indexOf('/') !== -1) {
          const fParts = s.split('/');
          return (parseFloat(fParts[0]) || 0) / (parseFloat(fParts[1]) || 1);
        }
        return parseFloat(s) || null;
      }

      const parts = dimStr.toLowerCase().split('x');
      return {
        l: parseNumber(parts[0]),
        w: parseNumber(parts[1]),
        h: parseNumber(parts[2]),
      };
    }

    const tbody = document.getElementById('tiered-pricing-body');
    const OriginalGroups = Object.values(grouped).sort((a, b) => {
      const aDim = parseDimensions(a.dimensions_display || (a.bundle || a.pallet).option1 || '');
      const bDim = parseDimensions(b.dimensions_display || (b.bundle || b.pallet).option1 || '');

      const aL = aDim.l || 0;
      const bL = bDim.l || 0;
      if (aL !== bL) return aL - bL;

      const aW = aDim.w || 0;
      const bW = bDim.w || 0;
      if (aW !== bW) return aW - bW;

      const aH = aDim.h || 0;
      const bH = bDim.h || 0;
      return aH - bH;
    });

    // Render Function
    function renderTable(groupsToRender) {
      let html = '';

      if (groupsToRender.length === 0) {
        html =
          '<tr><td colspan="5" style="text-align: center; padding: 2rem;">No boxes found matching these dimensions.</td></tr>';
      }

      groupsToRender.forEach((group) => {
        const bundle = group.bundle || group.pallet;
        const pallet = group.pallet;
        if (!bundle) return;

        const hasPallet = !!pallet;
        const isBundleAvail = bundle.available || bundle.inventory_policy === 'continue';
        const rawSku = bundle.sku || (pallet ? pallet.sku : null) || bundle.id;
        const skuDisplay = typeof rawSku === 'string' ? rawSku.split('-')[0] : String(rawSku);

        let bSize = parseInt(bundle.bundle_size, 10) || 1;
        let bInc = parseInt(bundle.increment, 10) || bSize;

        html += `<tr class="variant-row standard-row ${!isBundleAvail ? 'variant-unavailable' : ''}">`;

        html += `<td ${hasPallet ? 'rowspan="2"' : ''} class="col-stock">
                   <a href="${bundle.url}" class="variant-link">${skuDisplay}</a>
                 </td>`;
        html += `<td ${hasPallet ? 'rowspan="2"' : ''} class="col-dimensions">
                   <strong>${group.dimensions_display || bundle.option1 || ''}</strong>
                 </td>`;

        html += `<td class="col-bundle">${bSize}</td>`;
        html += `<td class="col-price">
                   <div class="price-wrapper">
                     <span class="price-value">${bundle.price_formatted}</span>
                     <span class="price-unit">Each</span>
                   </div>
                 </td>`;
        html += `<td class="col-add">
                   <div class="add-form-wrapper">
                     <input type="number" class="quantity-input standard-qty"
                       min="${bSize}" step="${bInc}" value="${bSize}"
                       data-moq="${bSize}" data-increment="${bInc}" aria-label="Quantity">
                     <button type="button" class="btn-add-cart" data-variant-id="${bundle.id}" data-tier="standard"
                       ${!isBundleAvail ? 'disabled' : ''}>
                       ${isBundleAvail ? 'Add' : 'Out'}
                     </button>
                   </div>
                 </td>`;
        html += `</tr>`;

        if (hasPallet) {
          let pSize = parseInt(pallet.pallet_size, 10) || parseInt(bundle.pallet_size, 10) || 1;
          const isPalletAvail = pallet.available || pallet.inventory_policy === 'continue';

          html += `<tr class="variant-row pallet-row ${!isPalletAvail ? 'variant-unavailable' : ''}">`;
          html += `<td class="col-bundle">${pSize}</td>`;
          html += `<td class="col-price">
                     <div class="price-wrapper">
                       <span class="price-value">${pallet.price_formatted}</span>
                       <span class="price-unit">Each</span>
                     </div>
                   </td>`;
          html += `<td class="col-add">
                     <div class="add-form-wrapper">
                       <input type="number" class="quantity-input pallet-qty"
                         min="${pSize}" step="${pSize}" value="${pSize}"
                         data-step-size="${pSize}" aria-label="Pallet Quantity">
                       <button type="button" class="btn-add-cart btn-add-pallet" data-variant-id="${pallet.id}"
                         data-tier="pallet" data-pallet-size="${pSize}" ${!isPalletAvail ? 'disabled' : ''}>
                         ${isPalletAvail ? 'Add' : 'Out'}
                       </button>
                     </div>
                   </td>`;
          html += `</tr>`;
        }
      });

      tbody.innerHTML = html;
      attachEvents();
    }

    // parseDimensions is now defined above to support initial sorting

    // Filters State
    let activeLengthMin = null;
    let activeLengthMax = null;

    function applyFilters() {
      const inputL = document.getElementById('filter-l').value;
      const inputW = document.getElementById('filter-w').value;
      const inputH = document.getElementById('filter-h').value;

      const valL = inputL ? parseFloat(inputL) : null;
      const valW = inputW ? parseFloat(inputW) : null;
      const valH = inputH ? parseFloat(inputH) : null;

      const filtered = OriginalGroups.filter((g) => {
        const b = g.bundle || g.pallet;
        const dims = parseDimensions(g.dimensions_display || b.option1 || '');

        // Match Search by Length Range (only runs if active)
        if (activeLengthMin !== null && activeLengthMax !== null) {
          if (!dims.l || dims.l < activeLengthMin || dims.l > activeLengthMax) {
            return false;
          }
        }

        // Match Search by Size
        if (valL !== null && valL !== dims.l) return false;
        if (valW !== null && valW !== dims.w) return false;
        if (valH !== null && valH !== dims.h) return false;

        return true;
      });

      const btnReset = document.getElementById('btn-reset-filters');
      if (btnReset) {
        if (valL !== null || valW !== null || valH !== null || activeLengthMin !== null) {
          btnReset.style.display = 'inline-block';
        } else {
          btnReset.style.display = 'none';
        }
      }

      renderTable(filtered);
    }

    // Generate Dynamic Length Pre-sets
    function generateLengthButtons() {
      const container = document.getElementById('dynamic-length-filters');
      if (!container) return;

      const allLengths = [
        ...new Set(
          OriginalGroups.map((g) => {
            const b = g.bundle || g.pallet;
            return parseDimensions(g.dimensions_display || b.option1 || '').l;
          }).filter((l) => l !== null)
        ),
      ].sort((a, b) => a - b);

      if (allLengths.length === 0) {
        container.innerHTML = '';
        return;
      }

      const minLength = Math.floor(allLengths[0]);
      const maxLength = Math.ceil(allLengths[allLengths.length - 1]);
      const rangeSpread = maxLength - minLength;

      let binSize = 5;
      if (rangeSpread > 40) binSize = 10;
      else if (rangeSpread <= 15) binSize = 3;

      const ranges = [];
      let currentMin = minLength;

      while (currentMin <= maxLength) {
        let currentMax = currentMin + binSize - 1;
        let lengthsInBin = allLengths.filter((l) => l >= currentMin && l <= currentMax);
        if (lengthsInBin.length > 0) {
          let actualMin = Math.floor(Math.min(...lengthsInBin));
          let actualMax = Math.ceil(Math.max(...lengthsInBin));
          ranges.push({
            min: actualMin,
            max: actualMax,
            label: actualMin === actualMax ? `${actualMin}"` : `${actualMin}-${actualMax}"`,
          });
        }
        currentMin += binSize;
      }

      let html = '';
      ranges.forEach((r) => {
        html += `<button class="btn-length" data-min="${r.min}" data-max="${r.max}">${r.label}</button>`;
      });
      container.innerHTML = html;
      bindLengthButtons();
    }

    generateLengthButtons();

    // Initial render
    renderTable(OriginalGroups);

    // Bind Size Filter
    const btnSearchSize = document.getElementById('btn-search-size');
    if (btnSearchSize) {
      btnSearchSize.addEventListener('click', () => {
        applyFilters();
      });
    }

    // Trigger filters intuitively while typing
    const sizeInputs = ['filter-l', 'filter-w', 'filter-h'];
    sizeInputs.forEach((id) => {
      const el = document.getElementById(id);
      if (el) {
        el.addEventListener('input', function () {
          // If the user explicitly types into 'L', clear the length button presets to avoid confusing overlaps
          if (id === 'filter-l' && this.value !== '') {
            const currentBtns = document.querySelectorAll('.btn-length');
            currentBtns.forEach((b) => b.classList.remove('active'));
            activeLengthMin = null;
            activeLengthMax = null;
          }
          applyFilters();
        });
      }
    });

    function bindLengthButtons() {
      const btnLengthsNode = document.querySelectorAll('.btn-length');

      btnLengthsNode.forEach((btn) => {
        btn.addEventListener('click', function () {
          if (this.classList.contains('active')) {
            // Double click turns it off
            this.classList.remove('active');
            activeLengthMin = null;
            activeLengthMax = null;
          } else {
            btnLengthsNode.forEach((b) => b.classList.remove('active'));
            this.classList.add('active');
            activeLengthMin = parseFloat(this.dataset.min);
            activeLengthMax = parseFloat(this.dataset.max);

            // Clear explicit L input to prevent overlapping conflicts
            const lInput = document.getElementById('filter-l');
            if (lInput && lInput.value !== '') {
              lInput.value = '';
            }
          }
          applyFilters();
        });
      });
    }

    // Global Reset
    const btnResetGlobal = document.getElementById('btn-reset-filters');
    if (btnResetGlobal) {
      btnResetGlobal.addEventListener('click', () => {
        document.getElementById('filter-l').value = '';
        document.getElementById('filter-w').value = '';
        document.getElementById('filter-h').value = '';
        document.querySelectorAll('.btn-length').forEach((b) => b.classList.remove('active'));
        activeLengthMin = null;
        activeLengthMax = null;
        applyFilters();
      });
    }
  });
  function attachEvents() {
    function validateQuantity(input) {
      if (input.classList.contains('standard-qty')) {
        const moq = parseInt(input.dataset.moq) || 1;
        const increment = parseInt(input.dataset.increment) || 1;
        let val = parseInt(input.value);
        if (isNaN(val) || val < moq) val = moq;

        const remainder = (val - moq) % increment;
        if (remainder !== 0) {
          val = val - remainder + increment;
        }
        input.value = val;
      } else if (input.classList.contains('pallet-qty')) {
        const step = parseInt(input.dataset.stepSize) || 1;
        let val = parseInt(input.value);
        if (isNaN(val) || val < step) val = step;

        if (val % step !== 0) {
          val = Math.ceil(val / step) * step;
        }
        input.value = val;
      }
    }

    document.querySelectorAll('.quantity-input').forEach((input) => {
      input.addEventListener('change', function () {
        validateQuantity(this);
      });
    });

    document.querySelectorAll('.btn-add-cart').forEach((btn) => {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        const wrapper = this.closest('.add-form-wrapper');
        const input = wrapper.querySelector('.quantity-input');
        const quantity = parseInt(input.value);
        const variantId = this.dataset.variantId;
        const tier = this.dataset.tier;

        if (!quantity || quantity <= 0) return;

        const properties = {};
        if (tier === 'pallet') {
          properties['_tier'] = 'pallet';
          const pPrice = this.dataset.palletPrice;
          const pSize = this.dataset.palletSize;
          if (pPrice) properties['_pallet_price'] = pPrice;
          if (pSize) properties['_pallet_size'] = String(pSize);
        } else if (tier === 'standard') {
          const stdInput = wrapper.querySelector('.standard-qty');
          if (stdInput) {
            if (stdInput.dataset.moq) properties['_bundle_size'] = String(stdInput.dataset.moq);
            if (stdInput.dataset.increment) properties['_increment'] = String(stdInput.dataset.increment);
          }
        }

        const originalText = this.innerText;
        this.innerText = '...';
        this.disabled = true;

        const formData = {
          items: [
            {
              id: variantId,
              quantity: quantity,
              properties: properties,
            },
          ],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data.status === 422) {
              alert(data.description);
              return;
            }
            try {
              const cartDrawer = document.querySelector('cart-drawer');
              if (cartDrawer && data.sections && typeof cartDrawer.renderContents === 'function') {
                cartDrawer.renderContents(data);
              } else if (data.sections && data.sections['cart-drawer']) {
                const doc = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
                ['cart-drawer-items', '.cart-drawer__footer'].forEach((sel) => {
                  const target = document.querySelector(sel);
                  const source = doc.querySelector(sel);
                  if (target && source) target.replaceWith(source);
                });
                if (cartDrawer) cartDrawer.classList.remove('is-empty');
              }
              const cartIconBubble = document.getElementById('cart-icon-bubble');
              if (cartIconBubble && data.sections && data.sections['cart-icon-bubble']) {
                const html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
                const section = html.querySelector('.shopify-section');
                cartIconBubble.innerHTML = section ? section.innerHTML : data.sections['cart-icon-bubble'];
              }
              document.dispatchEvent(new CustomEvent('cart:openDropdown'));
            } catch (e) {
              console.error('Error updating cart UI:', e);
            }
          })
          .catch((err) => {
            console.error('Fetch error:', err);
            alert('Failed to add to cart (Network Error)');
          })
          .finally(() => {
            this.innerText = originalText;
            this.disabled = false;
          });
      });
    });

    const SHARED_COLS = ['col-stock', 'col-dimensions'];

    document.querySelectorAll('.tiered-pricing-table .pallet-row').forEach((palletRow) => {
      if (palletRow.classList.contains('single-tier-pallet')) return;

      const standardRow = palletRow.previousElementSibling;
      if (!standardRow || !standardRow.classList.contains('standard-row')) return;

      const firstTd = standardRow.querySelector('td');
      if (!firstTd || firstTd.getAttribute('rowspan') !== '2') return;

      const allStandardTds = Array.from(standardRow.querySelectorAll('td'));
      const allPalletTds = Array.from(palletRow.querySelectorAll('td'));
      const sharedTds = allStandardTds.filter((td) => SHARED_COLS.some((c) => td.classList.contains(c)));
      const bundleSpecificTds = allStandardTds.filter((td) => !SHARED_COLS.some((c) => td.classList.contains(c)));

      function highlight(tds) {
        tds.forEach((td) => td.classList.add('cell-hovered'));
      }
      function clear() {
        [...allStandardTds, ...allPalletTds].forEach((td) => td.classList.remove('cell-hovered'));
      }

      sharedTds.forEach((td) => {
        td.addEventListener('mouseenter', () => highlight([...allStandardTds, ...allPalletTds]));
        td.addEventListener('mouseleave', clear);
      });

      bundleSpecificTds.forEach((td) => {
        td.addEventListener('mouseenter', () => highlight(allStandardTds));
        td.addEventListener('mouseleave', clear);
      });

      allPalletTds.forEach((td) => {
        td.addEventListener('mouseenter', () => highlight([...allPalletTds, ...sharedTds]));
        td.addEventListener('mouseleave', clear);
      });
    });

    function attachSingleFullRowHover(row) {
      const tds = row.querySelectorAll('td');
      function highlightRow() {
        tds.forEach((td) => td.classList.add('cell-hovered'));
      }
      function clearRow() {
        tds.forEach((td) => td.classList.remove('cell-hovered'));
      }
      row.addEventListener('mouseenter', highlightRow);
      row.addEventListener('mouseleave', clearRow);
    }

    document.querySelectorAll('.tiered-pricing-table tr.standard-row').forEach((row) => {
      const firstTd = row.querySelector('td');
      if (firstTd && firstTd.getAttribute('rowspan') === '2') return;
      attachSingleFullRowHover(row);
    });

    document.querySelectorAll('.tiered-pricing-table tr.single-tier-pallet').forEach((row) => {
      attachSingleFullRowHover(row);
    });
  }
